// src/pages/MainPage.jsx
import { Link } from "react-router-dom";
import Carousel from "../components/Carousel";
import FavoritesSection from "../components/ourFavorites";

export default function MainPage() {
  return (
    <>
      <main className="homepage">
        <section className="hero-left">
          <Carousel />
        </section>
        <aside className="hero-aside">
          <h1 className="site-title">Lucky Chopsticks</h1>
          <h2> 1407 Commercial Ave, Anacortes, WA </h2>
          <Link to="/menu" className="btn btn-primary">Menu</Link>
          <h2 className="callnow">
            <span className="call-line call-verb">Call </span>
            <a className="call-line call-phone" href="tel:+13605888899">(360) 588-8899</a>
            <span className="call-line call-action"> to order!</span>
          </h2>
        </aside>
      </main>
      <FavoritesSection />
    </>
  );
}
